import api from '@/api/explaur'

const state = function () {
  return {
  }
}

// getters
const getters = {
}

// actions
const actions = {
  get ({ state, commit }, request) {
    return api.get(request)
  },
  all ({ state, commit }, request) {
    return api.all(request)
  }
}

// mutations
const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
